import jwtDecode from 'jwt-decode';
import { verify, sign } from 'jsonwebtoken';
//
import axios from './axios';

// ----------------------------------------------------------------------

const isValidToken = (accessToken) => {
  if (!accessToken) {
    return false;
  }

  const decoded = jwtDecode(accessToken);
  const currentTime = Date.now() / 1000;

  return decoded.exp > currentTime;
};

//  const handleTokenExpired = (exp) => {
//   let expiredTimer;

//   window.clearTimeout(expiredTimer);
//   const currentTime = Date.now();
//   const timeLeft = exp * 1000 - currentTime;
//   console.log(timeLeft);
//   expiredTimer = window.setTimeout(() => {
//     console.log('expired');
//     // You can do what ever you want here, like show a notification
//   }, timeLeft);
// };

const setSession = (accessToken, client, uid) => {
  if (accessToken) {
    localStorage.setItem('accessToken', accessToken);
    localStorage.setItem('client', client);
    localStorage.setItem('uid', uid);
    axios.defaults.headers.common.client = client;
    axios.defaults.headers.common.uid = uid;
    // This function below will handle when token is expired
    // const { exp } = jwtDecode(accessToken);
    // handleTokenExpired(exp);
  } else {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('client');
    localStorage.removeItem('uid');
    delete axios.defaults.headers.common.client;
    delete axios.defaults.headers.common.uid;
  }
};

const setToken = (accessToken) => {
  localStorage.setItem('accessToken', accessToken);
};

const setPartner = (partner) => {
  localStorage.setItem('partner', JSON.stringify(partner));
  axios.defaults.headers.common['Partner-Imitate'] = partner.id;
};

const resetPartner = () => {
  localStorage.removeItem('partner');
  delete axios.defaults.headers.common['Partner-Imitate'];
};

export { isValidToken, resetPartner, setPartner, setSession, setToken, verify, sign };
